import styled from "styled-components";
/* import { keyframes } from "styled-components"; */

export const HeroContainer = styled.div`
  background: #0c0c0c;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  padding-top: calc(var(--navH) + env(safe-area-inset-top));
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  z-index: 1;

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.1) 20%,
        rgba(0, 0, 0, 0.7) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 20, 0.3) 0%, transparent 100%);
    z-index: 2;
  }

  @media (orientation: landscape) and (max-height: 450px) {
    /* iPhone landscape: avoid hero content overlapping the next section */
    height: auto;
    min-height: 100vh;
    align-items: center;
    padding-top: calc(var(--navH) + 12px);
    padding-bottom: 0;
  }

  /* Use dynamic viewport height in Safari to avoid toolbar gaps */
  @supports (-webkit-touch-callout: none) {
    height: 100dvh;
  }
`;

export const HeroBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const VideoBg = styled.video`
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  background: #232a34;
`;

export const HeroContent = styled.div`
  z-index: 3;
  max-width: 1200px;
  width: 100%;
  position: relative;
  margin: 0 auto;
  padding: 8px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (orientation: landscape) and (max-height: 450px) {
    padding-top: 0;
  }
`;

export const HeroH1 = styled.h1`
  color: #fff;
  font-size: 44px;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 40px;
  }

  @media screen and (max-width: 480px) {
    font-size: 30px;
  }

  @media (orientation: landscape) and (max-height: 450px) {
    font-size: 32px;
  }
`;

/* export const pulsate = keyframes`
0% {opacity: 1}
50% {opacity: 0}
100% {opacity: 1}
`; */

export const HeroP = styled.p`
  margin-top: 24px;
  color: #fff;
  font-size: clamp(16px, 4vw, 22px);
  line-height: 1.45;
  text-align: center;
  max-width: 520px;
  text-wrap: balance;
  ${
    "" /*   animation-name: ${pulsate};
  animation-duration: 1.5s;
  animation-iteration-count: infinite; */
  }

  @media screen and (max-width: 480px) {
    font-size: 17px;
  }

  @media (orientation: landscape) and (max-height: 450px) {
    margin-top: 14px;
    font-size: 18px;
    max-width: 720px;
  }
`;

export const HeroSummary = styled.p`
  margin-top: 10px;
  color: rgba(247, 248, 250, 0.85);
  font-size: 16px;
  text-align: center;
  max-width: 500px;
  line-height: 1.5;
`;

export const HeroBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
  gap: 12px;

  @media (orientation: landscape) and (max-height: 450px) {
    margin-top: 18px;
  }
`;

export const HeroButton = styled.a`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? "#ffcb66" : "#010606")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px 48px" : "12px 20px")};
  width: auto;
  max-width: 100%;
  text-align: center;
  font-size: clamp(15px, 4vw, ${({ fontBig }) => (fontBig ? "20px" : "16px")});
  letter-spacing: 0.01em;
  min-width: 220px;
  max-width: 360px;
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? "#FFF" : "#ffcb66")};
  }
`;

export const HeroSecondaryButton = styled(HeroButton)`
  margin-top: 12px;
`;

export const HeroFootnote = styled.p`
  margin-top: 14px;
  color: rgba(247, 248, 250, 0.75);
  font-size: 14px;
  text-align: center;
`;

export const HeroLink = styled.a`
  color: #ffcb66;
  text-decoration: underline;
`;
